export enum EXTENSIONS_REQUEST_IDENTIFIERS {
  GET_EXTENSIONS_SUBSCRIPTIONS = 'extensions.subscriptions.get',
  GET_EXTENSIONS_SUBSCRIPTION_QUOTA = 'extensions.quota.get'
}

export enum CANCEL_REQUEST_REASON {
  VOLUNTARY = 'VOLUNTARY',
  INVOLUNTARY = 'INVOLUNTARY'
}

export enum USER_SUBSCRIPTION_STATUS {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DELAYED = 'DELAYED',
  CANCELED = 'CANCELED'
}
